import React from "react"
import { getTimeZoneAbbreviation } from '../../utils'
import moment from "moment";
import { zonedTimeToUtc } from "date-fns-tz";

import { compose } from "redux"
import { duckify, singleDuck } from "../../utils/duckify"
import { customers } from 'ducks'

import { Button, Form, Col, Row } from 'react-bootstrap'
import LinkButton from "../LinkButton/LinkButton";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes'
import { Formik } from 'formik'
import classNames from "classnames";
import DatePicker from "react-datepicker"
import ValidationErrors from "../forms/ValidationErrors";
import { setHours, setMinutes } from "date-fns";

const AutoDatePicker = ({ id, errors, locale, onChange, value }) => {
  const dateFormat = global.I18n.time.formats.default_date_fns_datetime // Used for react-DatePicker formating

  return (
    <Form.Group as={Row} className={classNames('mb-3', errors.name ? 'has-error' : null)}>
      <Col xs={12} className="auto-date-picker" id={id}>
        <DatePicker
          selected={value}
          onChange={onChange}
          locale={locale}
          showTimeSelect
          isClearable
          timeFormat="p"
          dateFormat={dateFormat}
          timeIntervals={15}
          injectTimes={[
            setHours(setMinutes(new Date(), 59), 23),
          ]}
        />
        <span className="timezone">
          {value ? getTimeZoneAbbreviation(value) : ''}
        </span>
      </Col>
    </Form.Group>
  )
}

const CustomGradeInputRow = ({ allDucksReady, customer, globalDatesConfig, gradeSchoolYear, onSubmit, setIsEditing }) => {
  const initialValues = gradeSchoolYear
  const dateFormat = global.I18n.time.formats.default_date_fns_datetime // Used for react-DatePicker formating
  if (allDucksReady) {
    // Used for react-DatePicker selected input, don't want to format the formatted time possibly time jumping too many times
    const dateInputFormat = global.I18n.time.formats.default_moment_minutes
    if (!!initialValues.auto_open_date && gradeSchoolYear.auto_open_date) {
      initialValues.auto_open_date = moment(gradeSchoolYear.auto_open_date, dateInputFormat).toDate()
    }
    if (!!initialValues.auto_close_date && gradeSchoolYear.auto_close_date) {
      initialValues.auto_close_date = moment(gradeSchoolYear.auto_close_date, dateInputFormat).toDate()
    }
  }

  const handleCancel = () => {
    setIsEditing(false)
  }
  const directEnrollEnabled = customer && customer.direct_enroll_enabled

  return (
    <Formik
      initialValues={initialValues}
      validateOnBlur={false}
      validateOnChange={false}
      onSubmit={(values, { setErrors }) => {
        if (values.auto_open_date) {
          values.auto_open_date = zonedTimeToUtc(values.auto_open_date, customer.time_zone)
        }
        if (values.auto_close_date) {
          values.auto_close_date = zonedTimeToUtc(values.auto_close_date, customer.time_zone)
        }

        delete values.is_collected
        delete values.is_waitlisted
        delete values.reasons
        delete values.applicant_count
        return (onSubmit(values, { setErrors, setIsEditing }))
      }}
    >
      {({
        values,
        errors,
        isSubmitting,
        handleChange,
        handleSubmit,
        setFieldValue,
      }) => {
        return (
          <React.Fragment>
            <tr className={Object.keys(errors).length > 0 ? 'errors' : 'hidden'}>
              <td colSpan={8}>
                <ValidationErrors errors={errors}></ValidationErrors>
              </td>
            </tr>
            <tr className="custom-grade-edit">
              <td></td>
              <td>
                <AutoDatePicker
                  id={'auto-open-date'}
                  locale={customer.locale}
                  errors={errors}
                  onChange={e => setFieldValue('auto_open_date', e)}
                  value={values.auto_open_date}
                />
              </td>
              <td>
                <AutoDatePicker
                  id={'auto-close-date'}
                  locale={customer.locale}
                  errors={errors}
                  onChange={e => setFieldValue('auto_close_date', e)}
                  value={values.auto_close_date}
                />
              </td>
              <td>
                {!globalDatesConfig &&
                  <Form.Group as={Row} className={classNames('mb-3', errors.name ? 'has-error' : null)}>
                    <Col sm={10} className="max-applications">
                      <Form.Control
                        name='max_applicants'
                        type='text'
                        value={values.max_applicants}
                        onChange={handleChange}
                      />
                    </Col>
                  </Form.Group>
                }
              </td>
              <td className="auto-collect-selection">
                <Form.Group as={Row} className="mb-3">
                  <Col sm={12}>
                    <Form.Check
                      id="auto_collect-false"
                      name="auto_collect"
                      type="radio"
                      label={`Don't collect ${customer && customer.admin_admissions_terms['noun']}s`}
                      checked={!values.auto_collect}
                      onChange={() => setFieldValue('auto_collect', false)}
                    />
                    {!directEnrollEnabled && <Form.Check
                      id="auto_collect-true"
                      name="auto_collect"
                      type="radio"
                      label="Collect and auto-waitlist applications"
                      checked={values.auto_collect}
                      onChange={() => setFieldValue('auto_collect', true)}
                    />}
                  </Col>
                </Form.Group>
              </td>
              <td></td>
              <td className="grade-school-year-actions">
                <Button
                  variant="primary"
                  size="sm"
                  onClick={handleSubmit}
                  disabled={isSubmitting}
                >
                  Save
                </Button>
                <LinkButton
                  content={<FontAwesomeIcon icon={faTimes} color="grey" />}
                  onClick={handleCancel}
                  disabled={isSubmitting}
                />
              </td>
            </tr>
          </React.Fragment>
        )
      }}
    </Formik>
  )
}

const mapDucksToProps = () => ({
  customer: singleDuck(customers, 'current')
})

export default compose(duckify(mapDucksToProps))(CustomGradeInputRow)
